const middleware = (context) => {
    var _a;
    if (!context.app.$vsf.$magento.config.state.getCustomerToken()) {
        const homepage = context.localeRoute({ name: 'home' });
        context.redirect((_a = homepage === null || homepage === void 0 ? void 0 : homepage.path) !== null && _a !== void 0 ? _a : '/home');
    }
};
export default middleware;
